import React, { useState } from 'react';
import { Users, Clock, DollarSign, Download, Plus, Search, Filter, MoreVertical, Calendar, ArrowUpRight, ArrowDownRight } from 'lucide-react';
const employees = [{
  id: 1,
  name: 'Sarah Johnson',
  role: 'Head Chef',
  rate: 35.0,
  hours: 42,
  status: 'Active',
  avatar: 'SJ'
}, {
  id: 2,
  name: 'Michael Chen',
  role: 'Sous Chef',
  rate: 28.0,
  hours: 38,
  status: 'Active',
  avatar: 'MC'
}, {
  id: 3,
  name: 'Emma Wilson',
  role: 'Server',
  rate: 15.0,
  hours: 25,
  status: 'Active',
  avatar: 'EW'
}, {
  id: 4,
  name: 'David Rodriguez',
  role: 'Bartender',
  rate: 18.0,
  hours: 32,
  status: 'Active',
  avatar: 'DR'
}, {
  id: 5,
  name: 'Lisa Thompson',
  role: 'Hostess',
  rate: 16.0,
  hours: 20,
  status: 'On Leave',
  avatar: 'LT'
}];
export function PayrollView() {
  const [searchTerm, setSearchTerm] = useState('');
  return <div className="space-y-6" data-id="element-554">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-555">
        <div data-id="element-556">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-557">
            Payroll Management
          </h2>
          <p className="text-sm text-slate-500" data-id="element-558">
            Track hours, manage rates, and process payroll
          </p>
        </div>
        <div className="flex items-center gap-3" data-id="element-559">
          <button className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-xl text-sm font-bold text-slate-600 hover:bg-slate-50 transition-all shadow-sm" data-id="element-560">
            <Download size={16} data-id="element-561" />
            Export Report
          </button>
          <button className="flex items-center gap-2 px-4 py-2 bg-slate-900 text-white rounded-xl text-sm font-bold hover:bg-slate-800 transition-all shadow-lg shadow-slate-900/20" data-id="element-562">
            <Plus size={16} data-id="element-563" />
            Add Employee
          </button>
        </div>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-564">
        <StatCard label="Total Payroll (MTD)" value="$24,850" change="+5.2%" isUp icon={DollarSign} color="blue" data-id="element-565" />
        <StatCard label="Total Hours" value="1,240h" change="-2.1%" icon={Clock} color="emerald" data-id="element-566" />
        <StatCard label="Active Employees" value="18" change="0" icon={Users} color="purple" data-id="element-567" />
        <StatCard label="Avg. Hourly Rate" value="$22.40" change="+1.2%" isUp icon={DollarSign} color="amber" data-id="element-568" />
      </div>

      {/* Main Content */}
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden" data-id="element-569">
        <div className="p-6 border-b border-slate-50 flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-570">
          <div className="relative flex-1 max-w-md" data-id="element-571">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} data-id="element-572" />
            <input type="text" placeholder="Search employees..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 bg-slate-50 border-none rounded-xl text-sm focus:ring-2 focus:ring-slate-900/5 transition-all" data-id="element-573" />
          </div>
          <div className="flex items-center gap-2" data-id="element-574">
            <button className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-50 rounded-lg transition-all" data-id="element-575">
              <Filter size={20} data-id="element-576" />
            </button>
            <button className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-50 rounded-lg transition-all" data-id="element-577">
              <Calendar size={20} data-id="element-578" />
            </button>
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-579">
          <table className="w-full text-left" data-id="element-580">
            <thead data-id="element-581">
              <tr className="bg-slate-50/50" data-id="element-582">
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-583">
                  Employee
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-584">
                  Role
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-585">
                  Hourly Rate
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-586">
                  Hours (WTD)
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-587">
                  Gross Pay
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-588">
                  Status
                </th>
                <th className="px-6 py-4" data-id="element-589"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50" data-id="element-590">
              {employees.map(emp => <tr key={emp.id} className="hover:bg-slate-50/50 transition-colors group" data-id="element-591">
                  <td className="px-6 py-4" data-id="element-592">
                    <div className="flex items-center gap-3" data-id="element-593">
                      <div className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center text-[10px] font-bold text-slate-600" data-id="element-594">
                        {emp.avatar}
                      </div>
                      <span className="text-sm font-bold text-slate-900" data-id="element-595">
                        {emp.name}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-500 font-medium" data-id="element-596">
                    {emp.role}
                  </td>
                  <td className="px-6 py-4 text-sm font-bold text-slate-900" data-id="element-597">
                    ${emp.rate.toFixed(2)}
                  </td>
                  <td className="px-6 py-4 text-sm font-bold text-slate-900" data-id="element-598">
                    {emp.hours}h
                  </td>
                  <td className="px-6 py-4 text-sm font-black text-slate-900" data-id="element-599">
                    ${(emp.rate * emp.hours).toLocaleString()}
                  </td>
                  <td className="px-6 py-4" data-id="element-600">
                    <span className={`px-2 py-1 rounded-full text-[10px] font-bold uppercase ${emp.status === 'Active' ? 'bg-emerald-50 text-emerald-600' : 'bg-amber-50 text-amber-600'}`} data-id="element-601">
                      {emp.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-602">
                    <button className="p-1 text-slate-400 hover:text-slate-600 opacity-0 group-hover:opacity-100 transition-all" data-id="element-603">
                      <MoreVertical size={16} data-id="element-604" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="p-6 border-t border-slate-50 bg-slate-50/30" data-id="element-605">
          <div className="flex items-center justify-between" data-id="element-606">
            <p className="text-xs text-slate-500 font-medium" data-id="element-607">
              Showing 5 of 18 employees
            </p>
            <div className="flex gap-2" data-id="element-608">
              <button className="px-3 py-1 bg-white border border-slate-200 rounded-lg text-xs font-bold text-slate-400 cursor-not-allowed" data-id="element-609">
                Previous
              </button>
              <button className="px-3 py-1 bg-white border border-slate-200 rounded-lg text-xs font-bold text-slate-600 hover:bg-slate-50" data-id="element-610">
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}
function StatCard({
  label,
  value,
  change,
  isUp,
  icon: Icon,
  color
}: any) {
  const colors: any = {
    blue: 'bg-blue-50 text-blue-600',
    emerald: 'bg-emerald-50 text-emerald-600',
    purple: 'bg-purple-50 text-purple-600',
    amber: 'bg-amber-50 text-amber-600'
  };
  return <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm" data-id="element-611">
      <div className="flex items-center justify-between mb-4" data-id="element-612">
        <div className={`p-2 rounded-xl ${colors[color]}`} data-id="element-613">
          <Icon size={20} data-id="element-614" />
        </div>
        {change !== '0' && <div className={`flex items-center gap-0.5 text-xs font-bold ${isUp ? 'text-emerald-600' : 'text-rose-600'}`} data-id="element-615">
            {isUp ? <ArrowUpRight size={14} data-id="element-616" /> : <ArrowDownRight size={14} data-id="element-617" />}
            {change}
          </div>}
      </div>
      <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1" data-id="element-618">
        {label}
      </p>
      <p className="text-2xl font-black text-slate-900" data-id="element-619">{value}</p>
    </div>;
}